import { Time } from 'ohzi-core';

export default class ApplicationView
{
  constructor(name, container)
  {
    this.name = name;
    this.container = container;
    this.containerEl = container[0];

    this.initialized = false;
    this.t = 0;
    this.hide_time = 0.5;
    this.is_hiding = false;
  }

  start()
  {
    this.initialized = true;
  }

  update()
  {
    if (this.is_hiding)
    {
      this.t += Time.delta_time;

      //if (this.t >= 10.5)
      if (this.t >= this.hide_time)
      {
        this.container.addClass('hidden');
        this.is_hiding = false;
      }
    }
  }

  on_resize()
  {
  }

  show(transition_delay = 0)
  {
    this.container.removeClass('hidden');
    this.containerEl.style['transition-delay'] = `${transition_delay}s`;
    this.containerEl.style.opacity = 1;
    this.containerEl.style['pointer-events'] = 'auto';
    this.containerEl.style['animation-name'] = undefined;
    this.is_hiding = false;
  }

  hide(transition_delay = 0)
  {
    this.t = 0;
    this.hide_time = 0.5;
    this.is_hiding = true;
    // this.containerEl.style['transition-delay'] = `${transition_delay}s`
    this.containerEl.style.opacity = 0;

    this.containerEl.style['pointer-events'] = 'none';
  }

  // Fade in container when showing
  show_fade(transition_delay = 2)
  {
    console.log(`[show_fade]`);
    this.container.removeClass('hidden');
    this.containerEl.style.opacity = 1;
    this.containerEl.style['animation-name'] = `fadeInOpacity`;
    this.containerEl.style['animation-iteration-count'] = `1`;
    this.containerEl.style['animation-timing-function'] = `ease-in`;
    this.containerEl.style['animation-duration'] = `${transition_delay}s`;

    this.containerEl.style['pointer-events'] = 'auto';
    this.is_hiding = false;
  }

  // Fade out container when hiding
  hide_fade(transition_delay = 2)
  {
    this.t = 0;
    this.hide_time =  transition_delay;
    this.is_hiding = true;
    this.containerEl.style.opacity = 0;

    this.containerEl.style['animation-name'] = `fadeOutOpacity`;
    this.containerEl.style['animation-iteration-count'] = `1`;
    this.containerEl.style['animation-timing-function'] = `ease-in`;
    this.containerEl.style['animation-duration'] = `${transition_delay}s`;

    this.containerEl.style['pointer-events'] = 'none';
  }

  width()
  {
    return this.containerEl.getBoundingClientRect().width;
  }

  height()
  {
    return this.containerEl.getBoundingClientRect().height;
  }
}
